import React from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  useMediaQuery,
} from '@material-ui/core';

import { useStyles } from '../styles';
import { normalizeTime } from 'src/helpers/calendar/normalizeTime';
import CheckboxIcon from 'src/assets/icons/web/checkbox.svg';
import CheckboxCheckedIcon from 'src/assets/icons/web/checkboxChecked.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
  calendarOptions,
  setSchedulesIds,
  tripData,
} from 'src/redux/Calendar/sliceCalendar';

export const SchedulesBlock = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width: 960px)');
  const { type, schedulesIds } = useSelector(calendarOptions);
  const data = useSelector(tripData);
  const schedules = data?.schedules || [];

  const handleChange = (id: number) => {
    const currentSchedulesIds = schedulesIds || [];
    const newSchedulesIds = currentSchedulesIds.includes(id)
      ? currentSchedulesIds.filter((i) => i !== id)
      : [...currentSchedulesIds, id];

    dispatch(setSchedulesIds(newSchedulesIds));
  };

  const chooseAllSchedules = () =>
    dispatch(setSchedulesIds(schedules.map((i) => i.id)));
  const clearAllSchedules = () => dispatch(setSchedulesIds([]));

  if (type === 'option' || !schedules.length) return null;

  return (
    <Box mt={4}>
      <Box width={1} p={1} mb={1} display="flex">
        <Typography
          style={{
            color: '#0073bb',
            cursor: 'pointer',
            textDecoration: 'underline dotted',
          }}
          onClick={chooseAllSchedules}>
          Select All
        </Typography>
        &nbsp;|&nbsp;
        <Typography
          style={{
            color: '#0073bb',
            cursor: 'pointer',
            textDecoration: 'underline dotted',
          }}
          onClick={clearAllSchedules}>
          Unselect All
        </Typography>
      </Box>
      <Box
        width={1}
        display="flex"
        flexWrap="wrap"
        style={{
          gap: '16px',
        }}>
        {schedules.map((item, index: number) => (
          <Box
            key={item.id}
            className={classes.checkboxItem}
            minWidth={140}
            maxWidth={140}>
            <FormControlLabel
              control={
                <Checkbox
                  color="default"
                  icon={<CheckboxIcon />}
                  checkedIcon={<CheckboxCheckedIcon />}
                  checked={!!schedulesIds?.includes(item.id)}
                  onChange={() => {
                    handleChange(item.id);
                  }}
                />
              }
              label={normalizeTime(item.hour, item.minute)}
              labelPlacement="end"
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
